module.exports = __webpack_public_path__ + "img/advice-10.80c74906.png";